// templates/BannerTemplate.ts
import { dom } from "@Engage.Core";
import { BaseTemplate } from "./BaseTemplate";
export class BannerTemplate extends BaseTemplate {
    constructor(action) {
        super(action);
    }
    render() {
        var _a, _b;
        dom.addClass(document.body, "banner-open");
        const location = ((_b = (_a = this.action) === null || _a === void 0 ? void 0 : _a.showWhat) === null || _b === void 0 ? void 0 : _b.Location) || "bottom";
        this.container.classList.add(`engage-${location}`);
        const temp = document.createElement("div");
        temp.innerHTML = this.getProcessedHtml();
        const legacy = temp.querySelector(".mg2bn");
        if (legacy && location === "bottom") {
            legacy.classList.add("bottom");
        }
        this.container.innerHTML = temp.innerHTML;
        this.executeScripts(this.container);
        this.mountToBody();
        this.applyUserState();
        this.applyTransitionIn();
        this.setupCloseHandler(() => {
            // remove banner-open class when banner is closed
            dom.removeClass(document.body, "banner-open");
        });
    }
}
